import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'limitNumber' })
export class LimitNumberPipe implements PipeTransform {

  /* transform(): Pipe que devuelve un límite si el valor original excede el límite dado
    value: Valor que se verificará
    limit: Valor que no debe exceder
    by: tipo de excedencia (mayor o menor)
  */
  transform(value: any, limit: number, by: string): number {
    switch (by) {
      // ↓ Verifica si es mayor que
      case "max": value = Number(value) > limit ? limit : Number(value); break;
      // ↓ Verifica si es menor que
      case "min": value = Number(value) < limit ? limit : Number(value); break;
    }
    // ↓ Devuelve el valor original o el límite si lo excede
    return value;
  }

}
